import { render, staticRenderFns } from "./reservation-tile.vue?vue&type=template&id=71d51011&scoped=true&"
import script from "./reservation-tile.vue?vue&type=script&lang=js&"
export * from "./reservation-tile.vue?vue&type=script&lang=js&"
import style0 from "./reservation-tile.vue?vue&type=style&index=0&id=71d51011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d51011",
  null
  
)

export default component.exports